module.exports = __webpack_public_path__ + "img/visa.bd687161.svg";